module.exports = __webpack_public_path__ + "static/media/sustainability.25e83073.mp4";